var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommercialawareness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(-1567 -469)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(1567 469)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_9cd55f5624caf609848135587eb3713f",
    "data-name": "9cd55f5624caf609848135587eb3713f",
    transform: "translate(1575 476.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M31.13,31.291,28.914,30.8a12.627,12.627,0,0,0-2-4.814l1.23-1.915a.723.723,0,0,0-.1-.862l-1.737-1.736a.683.683,0,0,0-.848-.083l-1.928,1.218a12.627,12.627,0,0,0-4.814-2l-.493-2.216a.688.688,0,0,0-.67-.547H15.114a.688.688,0,0,0-.67.547l-.493,2.216a12.628,12.628,0,0,0-4.814,2L7.223,21.389a.7.7,0,0,0-.862.083L4.624,23.208a.7.7,0,0,0-.082.862l1.217,1.915a12.627,12.627,0,0,0-2,4.814l-2.215.492a.688.688,0,0,0-.547.67v2.448a.688.688,0,0,0,.547.67l2.216.493a12.627,12.627,0,0,0,2,4.814L4.542,42.314a.683.683,0,0,0,.082.848L6.361,44.9a.723.723,0,0,0,.862.1l1.914-1.231a12.63,12.63,0,0,0,4.815,2l.492,2.215a.676.676,0,0,0,.67.534h2.448a.676.676,0,0,0,.67-.534l.493-2.215a12.628,12.628,0,0,0,4.814-2L25.467,45a.7.7,0,0,0,.848-.1l1.737-1.737a.7.7,0,0,0,.1-.848l-1.23-1.928a12.627,12.627,0,0,0,2-4.814l2.215-.493a.688.688,0,0,0,.547-.67V31.962a.688.688,0,0,0-.547-.67Zm-14.8,8.274a6.387,6.387,0,1,1,6.386-6.387,6.393,6.393,0,0,1-6.386,6.387Z",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M16.331,25.726a7.453,7.453,0,1,0,7.452,7.453,7.47,7.47,0,0,0-7.452-7.453Zm0,12.332a4.88,4.88,0,1,1,4.879-4.881,4.885,4.885,0,0,1-4.879,4.881Z",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M48.624,18.785,47.1,18.446a8.68,8.68,0,0,0-1.373-3.31l.846-1.316a.5.5,0,0,0-.065-.592l-1.195-1.194a.47.47,0,0,0-.582-.056l-1.326.836a8.68,8.68,0,0,0-3.31-1.372l-.338-1.523a.473.473,0,0,0-.46-.376H37.614a.473.473,0,0,0-.46.376l-.34,1.523A8.68,8.68,0,0,0,33.5,12.814l-1.316-.836a.482.482,0,0,0-.592.056L30.4,13.228a.482.482,0,0,0-.057.592l.837,1.317a8.68,8.68,0,0,0-1.373,3.31l-1.523.338a.473.473,0,0,0-.376.46v1.683a.473.473,0,0,0,.376.461l1.523.339a8.681,8.681,0,0,0,1.373,3.309l-.837,1.326a.47.47,0,0,0,.057.583L31.6,28.14a.5.5,0,0,0,.592.065l1.316-.846a8.683,8.683,0,0,0,3.31,1.373l.338,1.523a.465.465,0,0,0,.461.367H39.3a.462.462,0,0,0,.46-.367l.34-1.523a8.682,8.682,0,0,0,3.309-1.373l1.326.846a.484.484,0,0,0,.582-.065l1.194-1.194a.484.484,0,0,0,.066-.583l-.846-1.326a8.68,8.68,0,0,0,1.373-3.31l1.523-.338a.473.473,0,0,0,.376-.46V19.246a.473.473,0,0,0-.376-.461ZM38.45,24.473a4.39,4.39,0,1,1,4.39-4.39A4.395,4.395,0,0,1,38.45,24.473Z",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M38.45,14.96a5.122,5.122,0,1,0,5.122,5.122A5.135,5.135,0,0,0,38.45,14.96Zm0,8.477a3.354,3.354,0,1,1,3.355-3.355,3.358,3.358,0,0,1-3.355,3.355Z",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M30.5,8.75l-1.2-.266a6.818,6.818,0,0,0-1.079-2.6l.665-1.033a.39.39,0,0,0-.052-.466L27.9,3.447a.37.37,0,0,0-.458-.044L26.4,4.06a6.82,6.82,0,0,0-2.6-1.078l-.266-1.2a.371.371,0,0,0-.362-.3H21.854a.371.371,0,0,0-.362.3l-.266,1.2a6.818,6.818,0,0,0-2.6,1.078L17.592,3.4a.379.379,0,0,0-.465.044l-.938.938a.379.379,0,0,0-.044.466L16.8,5.885a6.82,6.82,0,0,0-1.078,2.6l-1.2.265a.371.371,0,0,0-.3.362v1.322a.371.371,0,0,0,.3.362l1.2.266a6.82,6.82,0,0,0,1.078,2.6L16.145,14.7a.369.369,0,0,0,.044.458l.938.938a.39.39,0,0,0,.465.052l1.034-.665a6.821,6.821,0,0,0,2.6,1.078l.266,1.2a.364.364,0,0,0,.362.288h1.322a.365.365,0,0,0,.362-.288l.265-1.2a6.82,6.82,0,0,0,2.6-1.078l1.042.665A.38.38,0,0,0,27.9,16.1l.938-.938a.38.38,0,0,0,.052-.458l-.665-1.041a6.82,6.82,0,0,0,1.079-2.6l1.2-.266a.371.371,0,0,0,.3-.362V9.112a.371.371,0,0,0-.3-.362Zm-7.991,4.468A3.448,3.448,0,1,1,25.96,9.77,3.452,3.452,0,0,1,22.511,13.218Z",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M22.51,5.745a4.024,4.024,0,1,0,4.025,4.024A4.034,4.034,0,0,0,22.51,5.745Zm0,6.66A2.635,2.635,0,1,1,25.146,9.77,2.638,2.638,0,0,1,22.51,12.4Z",
    fill: "#eee"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialawareness);
export default __webpack_public_path__ + "static/media/commercialawareness.be0b0612f46b5003df955c5ab29d09bf.svg";
export { ForwardRef as ReactComponent };